/** @format */

import React from 'react';
import { useDispatch } from 'react-redux';
import { useACARequestPolicies } from '../hooks/usePolicies';
import ACARequestsTable from '../components/ACARequestsTable';
import ExportPoliciesButton from '../components/ExportPoliciesButton';
import { setSelectedFormId } from 'state/slice/buttonSlice';

interface ACARequestsTableContainerProps {
  filter?: Record<string, any>;
}

const ACARequestsTableContainer: React.FC<ACARequestsTableContainerProps> = ({ filter }) => {
  const { policies, loading, error } = useACARequestPolicies(filter);
  const dispatch = useDispatch();

  const handleView = (policyId: string) => {
    dispatch(setSelectedFormId(policyId));
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
        <ExportPoliciesButton data={policies} loading={loading} />
      </div>
      <ACARequestsTable
        data={policies}
        loading={loading}
        error={error}
        onView={handleView}
      />
    </div>
  );
};

export default ACARequestsTableContainer;
